<div class="container">
  <div [hidden]="isApiDataLoaded" class="spinner-container relativeWithTopPadding">
    <div class="d-flex justify-content-center">
      <div class="spinner-border custom-spinner" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</div>
<div id="team-member-strengths" [innerHtml]="reportContent | safeHtml" *ngIf="isApiDataLoaded"></div>
